// iPadOS can identify itself as macOS and can have a mouse attached.
// Touch capability, rather than screen width or user agent, controls autofocus.
export const hasTouchInput = (browserWindow = window) =>
  browserWindow.navigator.maxTouchPoints > 0 ||
  Boolean(browserWindow.matchMedia?.('(any-pointer: coarse)')?.matches);
